import {
    onUnmounted,
    ref,
    watch,
} from '@vue/composition-api';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';

export function useSendSectionViewportVisibilityAnalyticsEvent(sectionName: string, threshold = 0.5) {
    const observerRef = ref<HTMLDivElement>();

    const observer = new IntersectionObserver(
        (entries) => {
            if (entries[0].isIntersecting) {
                AnalyticsSDK.getInstance().log('section_viewport_visibility', { section_name: sectionName });

                observer.disconnect();
            }
        },
        { threshold },
    );

    watch(() => observerRef.value, (value) => {
        if (value) {
            observer.observe(value);
        }
    });

    onUnmounted(() => {
        observer?.disconnect();
    });

    return {
        observerRef,
    };
}
